import { render, staticRenderFns } from "./ModuleClientInbox.vue?vue&type=template&id=a04e0c80&scoped=true&lang=pug&"
import script from "./ModuleClientInbox.vue?vue&type=script&lang=js&"
export * from "./ModuleClientInbox.vue?vue&type=script&lang=js&"
import style0 from "./ModuleClientInbox.vue?vue&type=style&index=0&id=a04e0c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04e0c80",
  null
  
)

export default component.exports